// extracted by mini-css-extract-plugin
module.exports = {"root":"gallery_root__cWbnA"};